module.exports = __webpack_public_path__ + "static/media/1.c2e73fe7.png";